import React, { useContext, useEffect, useState } from "react";
import "../css/CommonStyle.css";
import "../css/Header.css";
import ic_app_logo from "../img/autoland_logo_original.png";
import ic_my_account from "../img/ic_my_account.svg";
import ic_shopping_cart from "../img/ic_cart.svg";
import { ShoppingCartContext } from "./ShoppingCartContext";
import { Link } from "react-router-dom";
import axios from "axios";
import ic_search_white_icon from "../img/ic_search_header.png";

import { useNavigate, useSearchParams } from "react-router-dom";


function Header() {

    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const [keywordForDropDown, setKeywordForDropDown] = useState(searchParams.get('searchkey'))

    let emptyArray = []

    const { shoppingCart, setShoppingCart } = useContext(ShoppingCartContext)

    const [localStorageOrderItems, setLocalStorageOrderItems] = useState(null)

    const callLocalStorage = () => {

        let initialLocalStorageOrderItems = localStorage.getItem("autoland_ordered_items")

        //console.log("initialLocalStorageOrderItems ", initialLocalStorageOrderItems)

        let initialOrderArray = null;

        if (initialLocalStorageOrderItems != null) {
            initialOrderArray = JSON.parse(initialLocalStorageOrderItems)
            setLocalStorageOrderItems(initialOrderArray)
        }
    }

    useEffect(() => {

        callLocalStorage()
    }, [])

    useEffect(() => {

        //console.log(" shoppingCart changed ", shoppingCart)
        callLocalStorage()

    }, [shoppingCart])

    const handleKeyWordInput = (e) => {

        setKeywordForDropDown(e.target.value)
    }

    const clickedOnSearchButton = () => {


        let makeToSend = "ALL"
        let modelToSend = "ALL"
        let categoryToSend = "ALL"
        let subCategoryToSend = "ALL"
        let keyWordToSend = keywordForDropDown ? keywordForDropDown : "ALL"

        navigate(`/show_parts_list?makename=${makeToSend}&modelname=${modelToSend}&modelyear=${"2024"}&maincategory=${categoryToSend}&subcategory=${subCategoryToSend}&searchkey=${keyWordToSend}`)
        navigate(0);


    }

    return (
        <div className="Header-outer-container">

            <div className="Header-root-container container-xl">

                <Link to="/">
                    <img className="Header-app-logo" src={ic_app_logo} />
                </Link>

                <div className="Header-box-with-search-and-button-wrapper">
                    <div className="Header-box-with-search-and-button">
                        <input className="Header-search-box" placeholder="Enter Keyword or Part Number" value={keywordForDropDown} onChange={(e) => handleKeyWordInput(e)} />
                        <button className="Header-search-button" onClick={() => clickedOnSearchButton()} ><img src={ic_search_white_icon} /></button>
                    </div>
                </div>

                <div className="Header-right-side-items-container">

                    <div className="Header-right-side-icons-container">
                        <Link to="/cart" className="Header_glossy_button">
                            <span className="position-relative Header_image_and_counter">
                                {
                                    <label className="Header-cart-items-count">{localStorageOrderItems != null ? localStorageOrderItems.length : "0"}</label>
                                }
                                <img src={ic_shopping_cart} />
                            </span>
                            <label className="d-none d-sm-block ms-4">Cart</label>
                        </Link>

                        {/* <Link to="/account" className="Header_glossy_button ms-4">
                            <span className="position-relative">
                                <img src={ic_my_account} className="ms-2" />
                            </span>
                            <label className="d-none d-sm-block ms-4">Account</label>
                        </Link> */}


                    </div>

                </div>

            </div>
        </div>
    )
}

export default Header;